<div class="page-fix-form-info-view">
    <div class="pl-4 py-8 pr-10">
        <div class="row align-items-center">
            <div class="col-48 col-sm-24 text-center">
                <ng-content select="img-slot"></ng-content>
            </div>
            <div class="col-48 col-sm-24">
                <ng-content select="txt-slot"></ng-content>
            </div>
        </div>
    </div>
</div>
